import { EnvData } from "./types";
import useEnv from "./useEnv";
import useTenant from "./useTenant";

export const useEnvironmentAction = (
  action:
    | "read"
    | "create_token"
    | "delete_token"
    | "rename_token"
    | "update_policy"
    | "create_fact"
    | "delete_fact"
    | "update_environment"
    | "delete_environment",
  targetEnv?: EnvData
) => {
  const { selectedEnv } = useEnv();

  const env = targetEnv ? targetEnv : selectedEnv;

  if (!env) {
    return false;
  }

  return env.actions.includes(action);
};

export const useTenantAction = (
  action:
    | "read"
    | "create_user"
    | "update_user"
    | "delete_user"
    | "create_environment"
    | "view_billing"
) => {
  const { tenant } = useTenant();
  if (!tenant) {
    return false;
  }

  return tenant.actions.includes(action);
};
